import { TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { Mobile } from '../../../mobile.setup';

const parent = Mobile.pages.phoneNumberManagement;
const path = 'corporate-number-porting';
const title =
  'PAGE.MOBILE.PHONE_NUMBER_MANAGEMENT.CORPORATE_NUMBER_PORTING.TITLE';

const res = [
  'portNumber',
  'actions',
  'actions.download',
  'actions.cancel',
  'actions.schedule',
  'actions.copyPortingRequestId',
];

export const MobilePhoneNumberManagementCorporateNumberPortingTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
